<template>
    <div class="content__container">
<!--        <div v-if="isShowMenu" class="menu_couriers">-->
<!--            <menu_couriers-->
<!--                :key="'menu_couriers'"-->
<!--            />-->
<!--        </div>-->
        <div class="courier_new">
            <div class="rest_list_container">
                <button class="order__heading_back_arrow margin_left" @click.prevent="clickBackArrow">
                    <svg>
                        <use xlink:href="/icons/base.svg#back_arrow"></use>
                    </svg>
                </button>
                <div class="rest_list__item_rest_name">
                    {{ restCourierListTitle }}
                </div>
            </div>
            <div class="rest_list_container" style="padding-left: 8px;">
                <div class="rest_list__header">
                    <div class="rest_list__header_container">
                        <rest_list_header_item
                            v-for="item in restList"
                            :key="'rest_list_header_item_' + item.id"
                            :item="item"
                            @select_item_header="selectItemHeader"
                        />
                    </div>
                </div>
            </div>

            <div class="rest_list__scroll">
                <div class="rest_list__scroll_container">
                    <rest_list_item
                        v-for="item in locationsList"
                        :key="'rest_list_item_' + item.id"
                        :restItem="item"
                        :operationName="'courier_locations'"
                    />
                </div>
            </div>
        </div>
<!--        <modal-->
<!--            v-if="isModalLocationsCourierList && isMobileScreen"-->
<!--            :key="'modal_locations_courier_list'"-->
<!--        >-->
<!--            <template v-slot:content>-->
<!--                <div class="courier_new">-->
<!--                    <span class="courier_new_strip"></span>-->
<!--                    <div class="courier_new__modal">-->
<!--                        <div class="rest_list_container">-->
<!--                            <button class="order__heading_back_arrow margin_left" @click.prevent="clickBackArrow">-->
<!--                                <svg>-->
<!--                                    <use xlink:href="/icons/base.svg#back_arrow"></use>-->
<!--                                </svg>-->
<!--                            </button>-->
<!--                            <div class="rest_list__item_rest_name">-->
<!--                                {{ restCourierListTitle }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="rest_list_container">-->
<!--                            <div class="rest_list__header">-->
<!--                                <div class="rest_list__header_container">-->
<!--                                    <rest_list_header_item-->
<!--                                        v-for="item in restList"-->
<!--                                        :key="'rest_list_header_item_' + item.id"-->
<!--                                        :item="item"-->
<!--                                        @select_item_header="selectItemHeader"-->
<!--                                    />-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="rest_list__scroll">-->
<!--                            <div class="rest_list__scroll_container">-->
<!--                                <rest_list_item-->
<!--                                    v-for="item in locationsList"-->
<!--                                    :key="'rest_list_item_' + item.id"-->
<!--                                    :restItem="item"-->
<!--                                    :operationName="'courier_locations'"-->
<!--                                />-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </template>-->
<!--        </modal>-->
    </div>
</template>

<script>

import rest_list_header_item from "../../../rest/RestListHeaderItem.vue";
import rest_list_item from "../../../rest/RestListItem.vue";
import {changeBody} from "../../../../mixins/changeBody";
import spinner from "../../../loader/Spinner.vue";
import {createHelpers} from "vuex-map-fields";
import burger_menu from "../../../heading/BurgerMenu.vue";
import {screenSize} from "../../../../mixins/screenSize";
import spinner_button from "../../../loader/SpinnerButton.vue";
import {colorFunctions} from "../../../../mixins/colorFunctions";
import {mouseMoveScroll} from "../../../../mixins/mouseMoveScroll";
import menu_couriers from "../../../menu/courier_pos/MenuCouriers.vue";
import modal from "../../../modal/Modal.vue";
import {touchEvent} from "../../../../mixins/touchEvent";


const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "locations_courier_list",
    props: {},
    emits: [],
    mixins: [changeBody, screenSize, colorFunctions, mouseMoveScroll, touchEvent],
    components: {
        modal,
        menu_couriers,
        spinner_button,
        burger_menu,
        rest_list_header_item,
        rest_list_item,
        spinner,
    },
    data() {
        return {
            locationsList: [],
            restList: [],
            itemHeader: null,
            classScrollElementMouseMove: '.rest_list__header',
            scrollElementMouseMove: null,
            activeRest: null,
            isModalLocationsCourierList: true,
        }
    },
    created() {
        if (this.search_order && this.search_order.delivery_restaurants) {
            this.restList = this.search_order.delivery_restaurants;
            this.restList.forEach((item, index) => item.isSelect = index === 0)
        }
        if (this.restList.length !== 0) {
            this.clickRest();
        }
    },
    methods: {
        touchStartEvent(){
            if(this.touchElementClass === 'modal__wrapper') {
                setTimeout(() => {
                    this.moveTouchDown();
                }, 200);
            }
        },
        clickRest() {
            this.activeRest = this.restList.find(item => item.isSelect);
            if (this.activeRest.attached_locations && Array.isArray(this.activeRest.attached_locations)) {
                this.locationsList = this.activeRest.attached_locations;
            }
        },
        selectItemHeader(itemHeader) {
            this.$store.dispatch('couriers/SET_ACTIVE_AGGREGATOR', itemHeader);
            this.itemHeader = itemHeader;
            this.restList.forEach(item => item.isSelect = item.id === this.itemHeader.id);
            this.clickRest();
        },
        clickBackArrow() {
            //this.$router.push({path: '/new/'})
            this.$router.push({path: '/new/courier/create'});
        },
        moveTouchDown(){
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', false);
            this.$router.push({path: "/courier"});
        },

    },
    computed: {
        ...mCouriers([
            'search_order',
        ]),
        restCourierListTitle() {
            return `${this.__t('O.RESTAURANTS_TO_CALL_COURIER')}`;
        },
        isShowMenu() {
            return this.isMobileScreen;
        },
    },
}
</script>
